export default "__VITE_ASSET__BVtEsrth__"